import app from 'flarum/forum/app';
import * as routes from './routes';

export default function () {
    // The extension will not use the methods from app.route anymore, but we keep them for backward compatibility if other extensions use them
    app.route.formulaireFormShow = routes.formulaireFormShow;
    app.route.formulaireFormEdit = routes.formulaireFormEdit;
    app.route.formulaireSubmissionIndex = routes.formulaireSubmissionIndex;
    app.route.formulaireSubmission = routes.formulaireSubmission;
    app.route.formulaireProfile = routes.formulaireProfile;
}
